module.exports = __webpack_public_path__ + "static/media/4.jpg.d835a467.webp";